<template>
    <div class="d-inline-block align-top mb-2">
        <multiselect track-by="key"
                     :options="options"
                     :searchable="searchable"
                     label="name"
                     :multiple="multiple"
                     :preselect-first="is_preselected_first"
                     :allow-empty="empty"
                     :close-on-select="false"
                     :limit="limit" :limitText="limitText"
                     :show-labels="false"
                     :placeholder="trans[locale].selectionLang.search"
                     :customLabel="customLabel"
                     :clear-on-select="!multiple"
                     :filter-page-id="unique_filter_page_id"
                     @input="updateValueAction" v-model="selected">
            <template slot="placeholder" slot-scope="props">
                <span>{{ placeholder }}</span>
            </template>

            <!-- This this how items html looks like -->
            <template slot="option" slot-scope="props">
                <div>{{ props.option.name }}</div>
            </template>

            <!-- shows when no options in selection -->
            <template slot="noResult" slot-scope="props">
                <span>No result</span>
            </template>

        </multiselect>
    </div>
</template>

<script>

    export default {

        data() {
            return {
                selected: [],
                options: this.init_options,
                value: '',
                locale: window.locale,
                placeholder: this.init_placeholder,
            }
        },
        props: {
            filter: {
                type: String,
                required: true,
            },
            init_options: {
                type: Array,
                required: true,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            trigger_filter_refresh: {
                type: Boolean,
                default: false,
            },
            ignore_refresh_signal: {
                type: Boolean,
                default: false,
            },
            refresh_url: {
                type: String,
                default: '',
            },
            init_selected: {
                type: Array,
                default: () => [],
            },
            init_placeholder: {
                type: String,
                default: () => this.trans[this.locale].selectionLang.placeholder,
            },
            searchable: {
                type: Boolean,
                default: true,
                required:false
            },
            allow_empty: {
                type: Boolean,
                default: null,
                required:false
            },
            preselect_first: {
                type: Boolean,
                default: false,
                required:false
            },
            ignore_store: {
                type: Boolean,
                default: false,
                required:false
            },
            mounted_refresh:{
                type: Boolean,
                default: true,
                required: false
            },
            filter_first: {
              type: Boolean,
              default: false,
              required: false
            },
            filter_page_id: {
                type: String,
                default: null,
                required: false
            },
            ref_page_id: {
                type: String,
                default: null,
                required: false
            },
            allow_parent_multiple_options: {
                type: Boolean,
                default: false,
                required: false
            },
        },
        beforeDestroy() {
            if (!this.ignore_refresh_signal) {
				window.eventHub.$off('filter_refresh', this.fetchOption)
            }
        },
        mounted() {
            let self = this;
            this.selected = [];

            if (!this.ignore_store) {
                if (!this.multiple && _.size(this.$store.state.filters[this.unique_filter_page_id]) > 0) {
                    this.$store.state.filters[this.unique_filter_page_id] = [ _.first(this.$store.state.filters[this.unique_filter_page_id]) ];
                }

                if(!_.isNil(this.ref_page_id)){
                    if(_.size(this.$store.state.filters[(this.ref_page_id + '_' + this.filter)]) > 0){
                        this.$store.state.filters[this.unique_filter_page_id] = [ _.first(this.$store.state.filters[(this.ref_page_id + '_' + this.filter)]) ];
                    }
                }

                this.selected = _.filter(this.options, (option) => {
                    return _.indexOf(this.$store.state.filters[this.unique_filter_page_id], option.key) !== -1 ||
                        this.$store.state.filters[this.unique_filter_page_id] == option.key;
                });

                let load_init_selected = false;
                if (this.selected.length == 0) {
                    if (_.isUndefined(this.$store.state.filters[this.unique_filter_page_id]) ||
                        _.size(this.$store.state.filters[this.unique_filter_page_id].length) == 0 ||
                        _.isEmpty(this.$store.state.filters[this.unique_filter_page_id])
                    ) {
                        load_init_selected = true;
                    } else {
                        load_init_selected = false;
                    }
                }

                // Add init selected value into final selected v-model
                if (load_init_selected) {
                    _.forEach(this.init_selected, (value) => {
                        if (_.isUndefined(_.find(self.selected, ['key', value])) &&
                            !_.isUndefined(_.find(self.options, ['key', value]))) {
                            self.selected.push(_.find(self.options, ['key', value]));
                        }
                    });
                }
            } else {
                _.forEach(this.init_selected, (value) => {
                    if (!_.isUndefined(_.find(self.options, ['key', value]))) {
                        self.selected.push(_.find(self.options, ['key', value]));
                    }
                })
            }

            if(this.mounted_refresh){
                this.updateValueAction(this.selected);
            }

            if (!this.ignore_refresh_signal) {
				window.eventHub.$on('filter_refresh', this.fetchOption)
            }
            else if (this.trigger_filter_refresh) {
                this.$nextTick(() => {
					window.eventHub.$emit('filter_refresh', this.selected.map(item => item.key));
                });
            }
        },
        methods: {
            customLabel({key, name}) {
                return `${name}`
            },
            updateValueAction(values) {
                let _values = Array.isArray(values) ?
                    values : (values ? [values] : []);
                let _value = _values.map(value => value.key)
                let _filter = this.unique_filter_page_id

                // emit a refresh signal to other filters
                if (this.trigger_filter_refresh) {
					window.eventHub.$emit('filter_refresh', _value);
                }

                this.$store.commit('setFilter', {_filter, _value});
            },
            limitText(count) {
                return `${this.trans[this.locale].selectionLang.selected} (${count})`;
            },
            fetchOption(year_id) {
                if (_.isArray(year_id)) {
                    if (_.size(year_id) > 0) {
                        year_id = this.allow_parent_multiple_options ? year_id.join('|-|') : _.first(year_id);
                    } else {
                        year_id = null;
                    }
                }
                if (this.refresh_url) {
                    let self = this;
                    let url = this.refresh_url;
                    if (url.includes("?")) {
                        let urlArr = this.refresh_url.split('?');
                        url = urlArr[0];
                        if (_.isNull(year_id) || _.isUndefined(year_id)) {
                            url = url + '?' + urlArr[1];
                        } else {
                            url = url + '/' + year_id + '?' + urlArr[1];
                        }
                    } else {
                        if (!_.isNull(year_id) && !_.isUndefined(year_id)) {
                            url = url + '/' + year_id;
                        }
                    }

                    self.$store.commit('setSubmitting', true);
                    axios.get(url)
                        .then((response) => {
                            self.$nextTick(() => {
                                // update selection
                                self.options = response.data;

                                self.selected = _.filter(self.options, (option) => {
                                    return _.indexOf(this.$store.state.filters[self.unique_filter_page_id], option.key) !== -1 ||
                                        self.$store.state.filters[self.unique_filter_page_id] == option.key;
                                });

                                // refresh selected options
                                self.selected = _.filter(self.selected, function (o) {
                                    return _.find(self.options, ['key', o.key]) !== undefined;
                                });

                                // reset filter state
                                let _filter = self.unique_filter_page_id;
                                let _value = self.selected.map(item => item.key);
                                self.$store.commit('setFilter', {_filter, _value});
                            })

                            self.$store.commit('setSubmitting', false);
                        })
                        .catch((error) => {
                            self.$store.commit('setNotificationType', 'danger');
                            self.$store.commit('setNotification', error.response.data.message);
                            self.$store.commit('setSubmitting', false);
                        })
                }
            },
        },
        computed: {
            limit() {
                return this.multiple ? 0 : 1;
            },
            empty() {
                if (_.isNull(this.allow_empty))
                {
                    return this.multiple ? true : false;
                } else {
                    return this.allow_empty;
                }
            },
            is_preselected_first(){
                if(this.filter_first){
                    if(!_.isUndefined(this.unique_filter_page_id)){
                        if (_.isUndefined(this.$store.state.filters[this.unique_filter_page_id]) ||
                            _.size(this.$store.state.filters[this.unique_filter_page_id]) == 0 ||
                            _.isEmpty(this.$store.state.filters[this.unique_filter_page_id])
                        ) {
                            return true;
                        }
                    }
                    else if(this.preselect_first) {
                        return true;
                    }
                }
                else if(this.preselect_first) {
                    return true;
                }

                return false;
            },
            unique_filter_page_id(){
                if(!_.isNil(this.filter_page_id) && this.filter_page_id != ''){
                    this.$root.unique_page_id = this.filter_page_id;
                    this.$store.state.unique_page_id = this.filter_page_id;

                    return this.filter_page_id + '_' + this.filter;
                }

                this.$root.unique_page_id = '';
                this.$store.state.unique_page_id = '';

                return this.filter;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Select/Filter.vue